/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Login_Is_User_Allowed_To_Change_Pause_Reason_In_Login_MaskInputs */

const en_forms_users_settings_login_is_user_allowed_to_change_pause_reason_in_login_mask = /** @type {(inputs: Forms_Users_Settings_Login_Is_User_Allowed_To_Change_Pause_Reason_In_Login_MaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mask`)
};

const de_forms_users_settings_login_is_user_allowed_to_change_pause_reason_in_login_mask = /** @type {(inputs: Forms_Users_Settings_Login_Is_User_Allowed_To_Change_Pause_Reason_In_Login_MaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer kann Pausengrund ändern`)
};

/**
* | output |
* | --- |
* | "Mask" |
*
* @param {Forms_Users_Settings_Login_Is_User_Allowed_To_Change_Pause_Reason_In_Login_MaskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_login_is_user_allowed_to_change_pause_reason_in_login_mask = /** @type {((inputs?: Forms_Users_Settings_Login_Is_User_Allowed_To_Change_Pause_Reason_In_Login_MaskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Login_Is_User_Allowed_To_Change_Pause_Reason_In_Login_MaskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_login_is_user_allowed_to_change_pause_reason_in_login_mask(inputs)
	return de_forms_users_settings_login_is_user_allowed_to_change_pause_reason_in_login_mask(inputs)
});